import { memo, ReactNode } from 'react'
import cn from 'classnames'
import { IconTooltipHelp } from 'components/IconTooltip'

import s from './FieldLabel.module.less'

const UNIT_LABELS = {
  rub: '₽',
  weight: 'т',
  size: 'м³'
}

interface IProps {
  children?: ReactNode
  className?: string
  htmlFor?: string
  info?: string
  /** @deprecated В формах больше не нужно удалять отступ свехру */
  isNoPaddingTop?: boolean
  placement?: string
  unit?: 'rub' | 'weight' | 'size'
}

export const FieldLabel = memo(function FieldLabel({
  children = '',
  className,
  htmlFor,
  info,
  isNoPaddingTop,
  unit
}: IProps) {
  return (
    <label
      htmlFor={htmlFor}
      className={cn(className, s.root, {
        [s.root_noPaddingTop]: isNoPaddingTop,
        [s.root_info]: info
      })}
    >
      {children}
      {unit && `, ${UNIT_LABELS[unit]}`}
      {info && (
        <IconTooltipHelp className={s.info} placement="bottom-start">
          {info}
        </IconTooltipHelp>
      )}
    </label>
  )
})
